import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi, SourceTypeDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

class SourceTypesStore {
  sourceTypes: SourceTypeDto[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.sourceTypes.getSourceTypes();

    runInAction(() => {
      this.sourceTypes = data?.map((type) => ({ ...type, id: type.code })) ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const sourceTypesStore = new SourceTypesStore({ api: cmApi });
